<template>
  <p class="font-15">
    <span class="font-weight-medium pr-1">
      <template v-if="linha.idcategoria">Categoria:</template>
    </span>

    <span>
      <template v-if="linha.idcategoria">{{ `${linha.idcategoria} - ${linha.descricao_categoria}` }}</template>
      <template v-else>Todas as categorias</template>
    </span>
  </p>
</template>

<script>
export default {
  name: "DescricaoNivelLinha",
  props: {
    linha: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
